module.exports = __webpack_public_path__ + "static/img/mentor-siemens.e147d6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/mentor-siemens.svg
// module id = Az3z
// module chunks = 1